<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <app-datetime
            ref="handle"
            type="datetime"
            class="relative input"
            :class="options"
            v-model="content"
            v-bind="$attrs"
            @input="update()"
            slot="input"
            auto
        />
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'

    export default {
        name: 'app-field-text',

        components: {
            'app-field': Field,
            'app-label': Label,
            'app-datetime': Datetime
        },

        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            }
        },

        data: () => ({
            content: ''
        }),

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },

        methods: {
            update() {
                this.$emit('input', this.content)
            }
        },

        mounted() {
            if (this.value) {
                this.content = this.value;

                this.update();
            }
        },
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';

    .vdatetime {
        height: 2.125rem !important;
    }

    .vdatetime-input {
        @apply .absolute .pin .w-full .rounded-lg .py-2 .px-4;
    }

    .vdatetime-popup__header, .vdatetime-calendar__month__day--selected > span > span, .vdatetime-calendar__month__day--selected:hover > span > span {
        @apply .bg-blue;
    }
    .vdatetime-popup__actions__button, .vdatetime-year-picker__item--selected, .vdatetime-time-picker__item--selected {
        @apply .text-blue;
    }
</style>


// WEBPACK FOOTER //
// src/components/fields/inputs/DateTime.vue